import React from "react";
import { LocationIcon } from "@/icons/LocationIcon";
import { slimImage } from "@/service/utils";
import { StarIcon } from "@/icons";
import NoDishPicture from "@/images/no_dish_picture.svg";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useStores } from "@/store";
import { useFilterContext } from "@/ui/head-bar/filter-context";
import { getQuery } from "@/service/http";

function formatDistance(distance) {
  if (distance === null || distance === undefined || distance === "") return "";
  const meters = Number(distance);
  if (Number.isNaN(meters)) return String(distance);
  if (meters >= 1000) return `${(meters / 1000).toFixed(1)}Km`;
  return `${Math.round(meters)}m`;
}

export default function RestaurantCard({
  restaurant,
  className = "",
  isAd = false,
}) {
  const { paymentStore } = useStores();
  const history = useHistory();
  const data = restaurant || {};
  const {
    cover,
    name,
    ratings_avg,
    format_avg_price,
    cuisines = [],
    location = {},
    distance,
    tags = [],
  } = data;
  const { t } = useTranslation();
  const { region = "", lang = "" } = getQuery();
  const { getSearch } = useFilterContext();
  const title = name || "";
  const rating = ratings_avg ? Number(ratings_avg).toFixed(1) : "0.0";
  const price = `${t("Browse.avgPrice")}${format_avg_price}`;
  const cuisineNames = cuisines
    .map((c) => (typeof c === "string" ? c : c?.name))
    .filter(Boolean)
    .slice(0, 2);
  const address = location?.name;
  const distanceLabel = formatDistance(distance);
  const imageSrc = cover ? slimImage(cover, "/w/128/h/128") : NoDishPicture;
  const onClick = () => {
    history.push(`/restaurants/${restaurant.id}?${getSearch()}`);
    if (restaurant.website_detail_url) {
      paymentStore.setCompleteUrl(restaurant.website_detail_url);
      window.top.postMessage(
        {
          type: "other",
          params: {
            url: restaurant.website_detail_url,
            region,
            lang,
          },
        },
        "*"
      );
    }
  };

  return (
    <div
      className={`explore-restaurant-card ${className}`.trim()}
      onClick={onClick}
    >
      <div className="explore-restaurant-card__media" aria-hidden="true">
        <img
          alt=""
          src={imageSrc}
          onError={(e) => {
            e.target.src = NoDishPicture;
          }}
        />
        {isAd && (
          <div className="explore-restaurant-card__ad">{t("Browse.ad")}</div>
        )}
      </div>

      <div className="explore-restaurant-card__content">
        <div className="explore-restaurant-card__title">{title}</div>

        <div className="explore-restaurant-card__meta">
          <div className="explore-restaurant-card__rating">
            <StarIcon
              className="explore-restaurant-card__star"
              aria-hidden="true"
            />
            <span className="explore-restaurant-card__meta-text">{rating}</span>
          </div>

          <span className="explore-restaurant-card__meta-text">{price}</span>

          {cuisineNames.length > 0 && (
            <div className="explore-restaurant-card__cuisines">
              <span className="explore-restaurant-card__cuisine">
                {cuisineNames[0]}
              </span>
              {cuisineNames[1] && (
                <span className="explore-restaurant-card__cuisine-sep" />
              )}
              {cuisineNames[1] && (
                <span className="explore-restaurant-card__cuisine">
                  {cuisineNames[1]}
                </span>
              )}
            </div>
          )}
        </div>

        <div className="explore-restaurant-card__address">
          <div className="explore-restaurant-card__address-left">
            <LocationIcon
              size={16}
              className="explore-restaurant-card__address-icon"
              aria-hidden="true"
            />
            <span className="explore-restaurant-card__address-text">
              {address}
            </span>
          </div>
          <span className="explore-restaurant-card__distance">
            {distanceLabel}
          </span>
        </div>

        {tags.slice(0, 2).map((tag, index) => (
          <div
            className="explore-restaurant-card__tag"
            key={`${tag.name}-${index}`}
          >
            <img
              src={tag.icon_url}
              alt=""
              className={`explore-restaurant-card__tag-icon`}
            />
            <span className="explore-restaurant-card__tag-text">
              {tag.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
